module.exports = __webpack_public_path__ + "b553da506077488bc65289e10841d527.woff";